export default class {
  constructor(params = {}) {
    let d = this.constructor.defaultValue()
    d['i'] = ++this.constructor.uuid
    for (let k of Object.keys(d)) {
      this[k] = d[k]
    }
    for (let k of Object.keys(params)) {
      if (k == "i" && params[k] == null ) continue
      let v = params[k]
      if (k == "accepting_date") {
        if (typeof v == "string") {
          v = new Date(v)
        }
      }
      this[k] = v
    }
  }


  static initialize(o){
    this.books = o.books
    this.accepting_order_routes = o.accepting_order_routes
    this.agencies = o.agencies
    this.final_book_shop_agencies = o.final_book_shop_agencies
    this.shop_people = o.shop_people
    this.deliver_types = o.deliver_types
    this.sales_people = o.sales_people
    return true
  }

  static importCsvArray(array) {
    let d = this.defaultValue()
    let agency = this.agencies.find(item => item.name == array[0] || item.code == array[0])
    if(agency)
      d.agency_code = `${agency.code}`
    d.agency_shop_code = `${array[1]}`
    d.isbn = `${array[2]}`
    d.order_number = array[3]
    d.kyakutyu_memo = array[4]
    let order_route = this.accepting_order_routes.find(item => item.name == array[5] || item.id == array[5])
    if(order_route)
      d.order_route_id = order_route.id
    let deliver_type = this.deliver_types.find(item => item.name == array[6] || item.id == array[6])
    if(deliver_type)
      d.deliver_type_id = deliver_type.id
    let sales_person = this.sales_people.find(item => item.name == array[7] || item.id == array[7])
    if(sales_person)
      d.sales_person_id = `${sales_person.id}`
    d.bibo = array[8]
    d.shop_person = array[9]
    d.book_shop_name = array[10]
    d.bansen = array[11]

    return new this(d)
  }

  static defaultValue() {
    if (this.uuid == undefined) {
      this.uuid = 0
    }
    return {
      id: null,
      isbn: null,
      agency_shop_code: null,
      agency_code: null,
      order_number: null,
      order_route_id: null,
      deliver_type_id: null,
      book_shop_name: null,
      shop_code: null,
      bansen: null,
      sales_person_id: null,
      kyakutyu_memo: null,
      bibo: null,
      shop_person: null,
      accepting_date: new Date(),
      _destroy: null
    }
  }

  book_name(){
    return 'bbbbbbb'
    if (!this.isbn) return ''
    let a = this.books.filter(book => book.isbn == this.isbn)
    return a.length > 0 ? `${a[0].name}: ${a[0].isbn}` : ''
  }

}
